export default "__VITE_ASSET__50bde695__"